import { useFormContext, Controller } from 'react-hook-form'
import { Input } from '@cb/apricot-react'
import { CBInputMethod } from '@cb/apricot'
import { FIELD_ZIP } from '../constants'
import { validatePostalCode, validateFieldState } from '../validations'

function SchoolZipFilter({ disabled, studentCountry }) {
  const { control } = useFormContext()

  useEffect(() => {
    CBInputMethod()
  }, [])

  if (studentCountry === 'US') {
    return (
      <>
        <Controller
          control={control}
          name={FIELD_ZIP}
          disabled={disabled}
          rules={{
            validate: value => validatePostalCode(true)(value),
          }}
          render={({
            field: { onChange, onBlur, value, disabled, name },
            fieldState: { invalid, isDirty, isTouched, error },
          }) => (
            <Input
              label="Filter by School ZIP (used for school search)"
              name={name}
              value={value}
              onChange={value => onChange(value)}
              onBlur={value => onBlur(value)}
              clearable
              floating={false}
              autoComplete="off"
              maxLength="5"
              disabled={disabled}
              validation={validateFieldState({ invalid, isDirty, isTouched, error, value })}
              validationMsg={error?.message}
            />
          )}
        />
        <p className="cb-font-size-small">
          If multiple schools are listed after you enter your school name, use this field to find
          your school by ZIP code.
        </p>
      </>
    )
  }

  return null
}

export default SchoolZipFilter
